<template>
    <div class="panel-body">
        <button class="btn btn-success" data-target="#ModalBuySMS"
                        data-toggle="modal" href="#"><i class="fa fa-cart-plus"></i> Comprar</button>
        <div class="row">
            <div class="col-md-12">
                <filterable ref="filter" v-bind="filterable">
                    <thead slot="thead">
                        <tr>
                            <th>Número</th>
                            <th>Comprovante</th>
                            <th>Enviado em</th>
                        </tr>
                    </thead>
                    <tr slot-scope="{item}">
                        <td>{{item.numero}}</td>
                        <td>{{item.id_envio}}</td>
                        <td>{{formatDate(item.created_at)}}</td>
                    </tr>
                </filterable>
            </div>
        </div>
        <m-buy-sms></m-buy-sms>
    </div>
</template>

<script>
    import mBuySms from './m-buy-sms.vue';
    export default {
        components: {
            mBuySms
        },
        data() {
            return {
                filterable: {
                    url: '/api/sms-enviados',
                    storeAction: 'setSms',
                    storeName: 'sms.data',
                    model: 'sms',
                },
            };
        },
        computed: {
            sms() {
                return this.$store.state.sms.data;
            }
        },
        watch: {
            $route(data) {
                if (data.name === 'sms') {
                    this.prepareComponent();
                }
            }
        }
    };
</script>